module.exports = __webpack_public_path__ + "static/img/200268.8a112396.png";